import { CompanyDto } from './company-dto.model';


export class ProjectCompanyDistanceDto implements IProjectCompanyDistanceDto {
    id!: number;
    projectId!: number;
    companyId!: number;
    company!: CompanyDto;
    distanceKM!: number | undefined;
    isActive!: boolean;

    constructor(data?: IProjectCompanyDistanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.distanceKM = _data["distanceKM"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProjectCompanyDistanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCompanyDistanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["distanceKM"] = this.distanceKM;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IProjectCompanyDistanceDto {
    id: number;
    projectId: number;
    companyId: number;
    company: CompanyDto;
    distanceKM: number | undefined;
    isActive: boolean;
}

